import { useGiratudoStore } from '~/stores/apostatudo/giratudo';
import { fetchGiratudoStatusHandler } from '~/handlers/fetch-giratudo-status.handler';
import { postGiratudoParticipateHandler } from '~/handlers/post-giratudo-participate.handler';
import { fetchGiratudoLeaderboardHandler } from '~/handlers/fetch-giratudo-leaderboard.handler';
import { fetchGiratudoHistoryHandler } from '~/handlers/fetch-giratudo-history.handler';
import { fetchGiratudoPrizesHandler } from '~/handlers/fetch-giratudo-prizes.handler';

export const useGiratudo = () => {
  const giratudoStore = useGiratudoStore();
  const { userId, userName } = useUserData();

  async function fetchStatus() {
    if (!userId.value) return;

    giratudoStore.setStatusLoading(true);
    try {
      const status = await fetchGiratudoStatusHandler({ userId: userId.value });

      giratudoStore.setStatus(status);
    } finally {
      giratudoStore.setStatusLoading(false);
    }
  }

  async function participate(): Promise<string | null> {
    if (!userId.value) return null;

    giratudoStore.setParticipateError(null);

    const { ticketNumber, error } = await postGiratudoParticipateHandler({
      userId: userId.value,
      username: userName.value || undefined,
    });

    if (error) {
      giratudoStore.setParticipateError(error);

      return null;
    }

    giratudoStore.setAlreadyParticipated(true);

    return ticketNumber;
  }

  async function fetchLeaderboard(page = 1, perPage = 10) {
    giratudoStore.setLeaderboardLoading(true);
    try {
      const leaderboard = await fetchGiratudoLeaderboardHandler({
        userId: userId.value,
        page,
        perPage,
      });

      giratudoStore.setLeaderboard(leaderboard);
    } finally {
      giratudoStore.setLeaderboardLoading(false);
    }
  }

  async function fetchHistory(page = 1, perPage = 10) {
    if (!userId.value) return;

    giratudoStore.setHistoryLoading(true);
    try {
      const history = await fetchGiratudoHistoryHandler({
        userId: userId.value,
        page,
        perPage,
      });

      giratudoStore.setHistory(history);
    } finally {
      giratudoStore.setHistoryLoading(false);
    }
  }

  async function fetchPrizes(page = 1, perPage = 10) {
    if (!userId.value) return;

    giratudoStore.setPrizesLoading(true);
    try {
      const prizes = await fetchGiratudoPrizesHandler({
        userId: userId.value,
        page,
        perPage,
      });

      giratudoStore.setPrizes(prizes);
    } finally {
      giratudoStore.setPrizesLoading(false);
    }
  }

  return {
    fetchStatus,
    participate,
    fetchLeaderboard,
    fetchHistory,
    fetchPrizes,
  };
};
